import html2pdf from 'html2pdf.js';

export const generatePdf = async (
  styledClone: HTMLElement,
  filename: string
): Promise<void> => {
  await html2pdf()
    .from(styledClone)
    .set({
      margin: 4,
      filename,
      image: { type: 'jpeg', quality: 0.75 },
      html2canvas: { scale: 1.5 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
    })
    .save();
};
